/* @flow */

import WebshopDropLinkSettings from './WebshopDropLinkSettings'
import WebshopDropLink from './WebshopDropLink'

import { createWebshopBannerDefaultSettings } from '../WebshopBanner'
import { mergeWidgetSettings } from '../shared'

const widget = mergeWidgetSettings(
  {
    component: WebshopDropLink,
    settings: WebshopDropLinkSettings,

    available_only_in_modules: ['splash'],
    available_children: [],
    label: 'Drop link',

    default_settings: {
      drop_id: null,
      drop_filter_code: null,
      subbrand_id: null,
    },
    default_style: {},

    duplicate_reset_fields: ['banner'],
  },
  createWebshopBannerDefaultSettings()
)

export default widget
